var _link, _link2, _style, _style2, _style3, _style4, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutTlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), _style4 || (_style4 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C2C2C2;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#000073;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#7D5FB3;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: -2,
    className: "st0",
    width: 100,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 69,
    y: 34,
    className: "st1",
    width: 31,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    y: 34,
    className: "st2",
    width: 62,
    height: 94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutTlr);
export default __webpack_public_path__ + "static/media/layout-tlr.767a0c35342508a0ab7c70241360347d.svg";
export { ForwardRef as ReactComponent };